import { ExtraFiltersProps } from '@/types/ExtraFiltersProps';
import AppPageHeader from '../../AppPageHeader';
import { CustomerVehiclesFilterParamsReduced } from '@/core/domain/people/CustomerVehicles/CustomerVehicles.types';
import { Col, Form, Input, Row, Select } from 'antd';
import MaskedInput from 'react-text-mask';
import { licensePlateMask } from '@/utils/mask/commonMasks';
import BrandsInfiniteSelect from '../../BrandsInfiniteSelect';
import ModelsInfiniteSelect from '../../ModelsInfiniteSelect';
import { useState } from 'react';

const VehiclesFiltersTableModal: React.FC<
  ExtraFiltersProps<CustomerVehiclesFilterParamsReduced>
> = ({ setQueryParams, queryParams }) => {
  const [brandIdSelected, setBrandIdSelected] = useState();

  return (
    <AppPageHeader
      onSearch={(value) =>
        setQueryParams((prev) => ({ ...prev, licensePlate: value }))
      }
      extraFilters={
        <Form>
          <Row gutter={[24, 24]}>
            <Col span={24} md={12}>
              <MaskedInput
                className="ant-input"
                mask={licensePlateMask}
                guide={false}
                name="licensePlate"
                onChange={({ target: { value } }) =>
                  setQueryParams((prev) => ({
                    ...prev,
                    licensePlate: value.toUpperCase(),
                  }))
                }
                placeholder="Placa"
              />
            </Col>

            <Col span={24} md={12}>
              <Input
                name="chassi"
                onChange={({ target: { value } }) =>
                  setQueryParams((prev) => ({ ...prev, chassi: value }))
                }
                placeholder="Chassi"
              />
            </Col>

            <Col span={24} md={12}>
              <Select
                allowClear
                onChange={(value) =>
                  setQueryParams((prev) => ({ ...prev, active: value }))
                }
                style={{ width: '100%' }}
                placeholder="Atividade"
                defaultValue={true}
              >
                <Select.Option value={true}>Ativo</Select.Option>
                <Select.Option value={false}>Inativo</Select.Option>
              </Select>
            </Col>

            <Col span={24} md={12}>
              <BrandsInfiniteSelect
                allowClear
                style={{ width: '100%' }}
                placeholder="Marca"
                value={queryParams?.brandId}
                onChange={(value) => {
                  setBrandIdSelected(value);
                  setQueryParams((prev) => ({ ...prev, brandId: value }));
                }}
              />
            </Col>

            <Col span={24} md={12}>
              <ModelsInfiniteSelect
                disabled={!brandIdSelected}
                allowClear
                style={{ width: '100%' }}
                placeholder="Modelo"
                queryFilter={{ brandId: brandIdSelected }}
                queryEnable={!!brandIdSelected}
                onChange={(value) =>
                  setQueryParams((prev) => ({ ...prev, modelId: value }))
                }
              />
            </Col>
          </Row>
        </Form>
      }
    />
  );
};

export default VehiclesFiltersTableModal;
